const config = {
  serverUrl: window._env_.BACKEND_URL_REST,
  tokensecret: window._env_.TOKEN_SECRET,
};

export default config;
